module.exports = __webpack_public_path__ + "media/site_templates/www.localhomebuilders.net.au/images/feature_2-fef45092dcbbb91f916ed25476809124.jpeg";